module.exports = __webpack_public_path__ + "static/media/victor.125e8328.jpg";